import React from 'react';
import Icon from 'components/AppIcon';

const StatsCards = ({ stats }) => {
  const cards = [
    { label: 'Total Usuarios', value: stats?.total, icon: 'Users', bg: 'bg-blue-50', iconBg: 'bg-blue-100', iconColor: '#0891B2', change: '+3 este mes' },
    { label: 'Activos', value: stats?.active, icon: 'UserCheck', bg: 'bg-emerald-50', iconBg: 'bg-emerald-100', iconColor: '#059669', change: `${Math.round((stats?.active / stats?.total) * 100)}% del total` },
    { label: 'Pendientes', value: stats?.pending, icon: 'Clock', bg: 'bg-amber-50', iconBg: 'bg-amber-100', iconColor: '#D97706', change: 'Requieren revisión' },
    { label: 'Suspendidos', value: stats?.suspended, icon: 'UserX', bg: 'bg-red-50', iconBg: 'bg-red-100', iconColor: '#DC2626', change: 'Acceso restringido' },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {cards?.map((card) => (
        <div key={card?.label} className={`${card?.bg} rounded-xl p-4 border border-white/60 shadow-sm`}>
          <div className="flex items-start justify-between mb-3">
            <div className={`w-9 h-9 rounded-xl ${card?.iconBg} flex items-center justify-center`}>
              <Icon name={card?.icon} size={18} color={card?.iconColor} />
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-800 font-heading">{card?.value}</p>
          <p className="text-xs font-semibold text-gray-600 font-caption mt-0.5">{card?.label}</p>
          <p className="text-xs text-gray-400 font-caption mt-1">{card?.change}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsCards;